import React from "react";
import PropTypes from "prop-types";
import { pure } from "recompose";
import { defineMessages, injectIntl } from "react-intl";
import { renderHTML } from "../../utils/misc";
import styles from "./GuaranteeMessage.scss";
import classnames from "classnames";

export const msgs = defineMessages({
  ccPaymentDescription: {
    id: "checkout.payment_form.ccPaymentDescription",
    description: "Payment Type Description",
    defaultMessage:
      "Your credit card acts as a payment guarantee to cover cancelation or no-show costs acording to the service terms and conditions.",
  },
  ccDepositPaymentDescription: {
    id: "checkout.payment_form.ccDepositPaymentDescription",
    description: "Payment Type Description when has deposit",
    defaultMessage:
      "Your credit card serves as a guarantee and will be used according to the service terms and conditions.",
  },
});

function GuaranteeMessage({
  creditCardsList,
  description,
  depositTotal,
  intl: { formatMessage } = {},
}) {
  return (
    <div className={classnames("wbkv9-GuaranteeMessage", styles.paymentDescription)}>
      {creditCardsList}
      {!description &&
        typeof depositTotal !== "undefined" &&
        depositTotal !== null &&
        depositTotal > 0 && (
          <span
            dangerouslySetInnerHTML={renderHTML(formatMessage(msgs.ccDepositPaymentDescription))}
          />
        )}
      {((!description && typeof depositTotal === "undefined") ||
        depositTotal === null ||
        depositTotal <= 0) && (
        <span dangerouslySetInnerHTML={renderHTML(formatMessage(msgs.ccPaymentDescription))} />
      )}
    </div>
  );
}

GuaranteeMessage.propTypes = {
  items: PropTypes.array,
  description: PropTypes.oneOfType([PropTypes.element, PropTypes.bool]),
};

export default injectIntl(pure(GuaranteeMessage));
